import { Pause, Play } from "lucide-react";
import { useState } from "react";
import { markenLogos } from "./Marquee";

type Brand = { name: string; src: string };

const LogoRow = ({ brands, duplicate = false }: { brands: readonly Brand[]; duplicate?: boolean }) => (
  <ul className={`design-brand-row${duplicate ? " design-brand-copy" : ""}`} aria-hidden={duplicate || undefined} role="list">
    {brands.map((brand) => (
      <li key={brand.name}>
        <img
          src={brand.src}
          alt={duplicate ? "" : brand.name}
          width="120"
          height="40"
          loading="lazy"
          decoding="async"
          className={brand.name === "Michelin" ? "design-brand-michelin" : undefined}
        />
      </li>
    ))}
  </ul>
);

const BrandShowcase = ({ brands = markenLogos, label = "Unsere Reifenmarken", variant = "tyres" }: { brands?: readonly Brand[]; label?: string; variant?: "tyres" | "rims" }) => {
  const [paused, setPaused] = useState(false);
  const [touching, setTouching] = useState(false);

  return (
    <section className={`design-brands design-brands-${variant}`} aria-label={label}>
      <div className="design-brands-inner" data-paused={paused || touching}>
        <div
          className="design-brand-viewport"
          tabIndex={0}
          role="region"
          aria-label={label}
          onPointerDown={(event) => {
            if (event.pointerType === "mouse") return;
            event.currentTarget.setPointerCapture(event.pointerId);
            setTouching(true);
          }}
          onPointerUp={() => setTouching(false)}
          onPointerCancel={() => setTouching(false)}
          onLostPointerCapture={() => setTouching(false)}
        >
          <div className="design-brand-track">
            <LogoRow brands={brands} />
            <LogoRow brands={brands} duplicate />
          </div>
        </div>
        <button
          className="design-brand-pause"
          type="button"
          onClick={() => setPaused(!paused)}
          aria-label={paused ? "Markenlauf fortsetzen" : "Markenlauf pausieren"}
        >
          {paused ? <Play size={14} aria-hidden="true" /> : <Pause size={14} aria-hidden="true" />}
        </button>
      </div>
    </section>
  );
};

export default BrandShowcase;
